import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

//Components
import ListaRegrasVersoes from '../../../components/RegrasVersoes/ConsultaRegrasVersoes';

//Api
import regraVersaoSistema_api from '../../../api/regraVersaoSistema_api';
import setup_api from '../../../api/setup_api';
import secretaria_api from '../../../api/secretaria_api';

//Helpers
import { showMessage } from '../../../helpers/message';

//Context
import { useAuth } from '../../../context/auth';

// Consulta pública de Regras e Versões do Sistema (CE-3522/CE-3738).
// Sem login: consome os endpoints [AllowAnonymous] da API. O tenant vem do
// subdomínio (tratado em api/_api.js); a secretaria pode vir na querystring
// (?secretaria=) e, quando ausente, a API usa a primeira cadastrada.
export default function ConsultaRegrasVersoes() {

    const location = useLocation();

    //Estado de controle da lista de regras e versões publicadas
    const [regrasVersoes, setRegrasVersoes] = useState([]);

    const { setLoading, setLogoSecretaria, setLogoSistema, setLogoPrefeitura } = useAuth();

    const secretariaDaUrl = () => new URLSearchParams(location.search).get('secretaria');

    const loadLogoSecretaria = () => {
        secretaria_api.getLogotipo()
            .then(response => setLogoSecretaria(response.data))
            .catch(() => { /* logotipo é decorativo: não bloqueia a consulta */ });
    }

    const loadLogoTipos = () => {
        setup_api.GetLogotipos()
            .then(response => {
                setLogoPrefeitura(response.data.logotipoPrefeitura);
                if (response.data.logotipoSistema)
                    setLogoSistema(response.data.logotipoSistema);
            })
            .catch(() => { /* logotipo é decorativo: não bloqueia a consulta */ });
    }

    const loadRegrasVersoes = () => {
        setLoading(true);
        regraVersaoSistema_api.getListPublica(secretariaDaUrl())
            .then(response => setRegrasVersoes(response.data))
            .catch(e => showMessage("Erro", e.message, "error", null))
            .finally(() => setLoading(false));
    }

    //Busca o detalhe do item selecionado pelo hash, que é o identificador público
    const carregarDetalhe = (item) => {
        setLoading(true);
        return regraVersaoSistema_api.getItemByHash(item.hash)
            .then(response => response.data)
            .catch(e => {
                showMessage("Erro", e.message, "error", null);
                return null;
            })
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        loadLogoSecretaria();
        loadLogoTipos();
        loadRegrasVersoes();
    }, []);

    return (
        <>
            <h4 className='text-secondary mb-4'>Regras e Versões do Sistema</h4>
            <ListaRegrasVersoes itens={regrasVersoes} carregarDetalhe={carregarDetalhe} />
        </>
    )
}
